module.exports = __webpack_public_path__ + "static/media/Redes100.7c350d92.png";